import { ClFarmStore } from "@/domains/cl-farm/cl-farm-store"
import { ClFarmAlmType } from "@/domains/core"
import { SortBy } from "@/domains/liquidity-page/liquidity-page-store"
import { ILiquidityPool } from "@/domains/pools"
import { poolSearch } from "@/domains/pools/pool-search"
import { TableProcessor } from "@/domains/table-processor"

export const clFarmsProcessor = (
  pools: Array<ClFarmStore>,
  search: string | null,
  stakedOnly: boolean,
  alm: ClFarmAlmType,
  sortBy: SortBy,
) => {
  const processed = TableProcessor({
    rows: pools,
    filters: {
      static: [
        {
          name: "search text",
          field: "*",
          filterFunction: (row: ILiquidityPool) => {
            return poolSearch(row, search)
          },
        },
        {
          name: "alm",
          field: "*",
          filterFunction: (pool: ClFarmStore) => {
            // @ts-ignore
            if (alm === "all") return true

            return alm === pool.alm
          },
        },
      ],
      dynamic: [
        {
          name: "staked only",
          field: "*",
          filterFunction: (pool: ClFarmStore) => {
            if (!stakedOnly) {
              return true
            }

            const hasPoolAmount = pool.userBalance > 0n
            const hasStakedAmount = pool.gaugeUserBalance > 0n
            if (hasPoolAmount || hasStakedAmount) {
              return true
            }
            return false
          },
        },
      ],
    },
    sort: sortBy,
  })

  return processed
}
